var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongLeftI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.9999C1.25 11.791 1.33714 11.5915 1.49044 11.4496L6.89044 6.44957C7.10918 6.24704 7.42711 6.19328 7.70028 6.31263C7.97345 6.43198 8.15 6.70179 8.15 6.99989V11.2499H21.25V7.00003C21.25 6.58582 21.5858 6.25003 22 6.25003C22.4142 6.25003 22.75 6.58582 22.75 7.00003V17C22.75 17.4142 22.4142 17.75 22 17.75C21.5858 17.75 21.25 17.4142 21.25 17V12.7499H8.15V16.9999C8.15 17.298 7.97345 17.5678 7.70028 17.6872C7.42711 17.8065 7.10918 17.7528 6.89044 17.5502L1.49044 12.5502C1.33714 12.4083 1.25 12.2088 1.25 11.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongLeftI);
export default __webpack_public_path__ + "static/media/arrow-long-left-i.7f43a16f3c83cd6037bdc312d9c75e4d.svg";
export { ForwardRef as ReactComponent };